import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';

const BlogCard = ({ blog, featured = false }) => {
  if (featured) {
    return (
      <Link to={`/blog/${blog.id}`} className="featured-card">
        {blog.cover && (
          <div className="blog-card-cover">
            <img src={blog.cover} alt={blog.title} />
          </div>
        )}
        <div className="blog-card-body">
          <div className="featured-badge">Latest Post</div>
          <div className="blog-card-header">
            <span className="blog-card-category">{blog.category}</span>
            <span className="blog-card-date">{blog.date}</span>
            <span className="blog-card-readtime">{blog.readTime}</span>
          </div>
          <h2>{blog.title}</h2>
          <p className="blog-card-excerpt">{blog.excerpt}</p>
          <div className="blog-card-footer">
            <div className="blog-card-tags">
              {blog.tags?.map((tag) => (
                <span key={tag} className="blog-card-tag">#{tag}</span>
              ))}
            </div>
            <span className="read-more">
              Read more <FiArrowRight />
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link to={`/blog/${blog.id}`} className="blog-card">
      {blog.cover && (
        <div className="blog-card-cover">
          <img src={blog.cover} alt={blog.title} />
        </div>
      )}
      <div className="blog-card-body">
        <div className="blog-card-header">
          <span className="blog-card-category">{blog.category}</span>
          <span className="blog-card-date">{blog.date}</span>
          <span className="blog-card-readtime">{blog.readTime}</span>
        </div>
        <h3>{blog.title}</h3>
        <p className="blog-card-excerpt">{blog.excerpt}</p>
        <div className="blog-card-footer">
          <div className="blog-card-tags">
            {blog.tags?.map((tag) => (
              <span key={tag} className="blog-card-tag">#{tag}</span>
            ))}
          </div>
          <span className="read-more">
            Read more <FiArrowRight />
          </span>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
